<template>
    <div id="message">
        <top :topIndex="7"></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left :leftIndex="7"></left>
            <messageList v-if="ifDetail == 0" @toDetail="toDetail"></messageList>
            <messageDetail v-if="ifDetail == 1" :detailId="detailId" @goBack="goBack"></messageDetail>
        </div>
    </div>
</template>
<script>
import top from '../components/top.vue' //顶部
import left from '../components/left.vue' //左侧
import messageList from '../components/message_list.vue' //列表
import messageDetail from '../components/message_detail.vue' //详情
import { EventBus } from '@/utils/eventBus'
export default {
    components: {
        top, left, messageList, messageDetail
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
            ifDetail: 0, //0列表 1详情
            detailId: '',
            home: '',
        }
    },
    created() {
        const { id, home } = this.$route.query
        this.home = home || ''
        console.log('消息详情id=', id)
        if (id) {
            this.toDetail(id)
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        toDetail(id) {

            this.ifDetail = 1
            this.detailId = id
        },
        goBack() {
            if (this.home) {
                this.$router.go(-1)
            } else {
                this.ifDetail = 0
            }

        }
    }
}
</script>

<style>
#message {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}
</style>